module.exports = __webpack_public_path__ + "media/images/Marca-old-5a2578e4fbd947b5e644c99afe2b6641.png";